"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _spacing = _interopRequireDefault(require("./spacing"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  v1: {},
  v2: {
    textInput: {
      bordered: true
    },
    button: {
      radius: '2px',
      height: '32px',
      padding: _spacing["default"].small
    },
    textArea: {
      labelType: 'static',
      bordered: true
    },
    table: {
      headerHover: false,
      headerSeparator: true,
      headerBorder: '1px',
      resizeGripHeight: 'small',
      bottomBorder: true
    },
    dialog: {
      bottomBorder: true,
      topBorder: false,
      radius: '2px',
      backdropShade: 'light',
      titleHeight: 56,
      footerHeight: 64
    },
    checkbox: {
      shadowOnHover: false
    },
    radios: {
      shadowOnHover: false
    },
    chips: {
      bordered: false
    },
    badge: {
      bordered: false
    },
    list: {
      height: '32px'
    }
  }
};
exports["default"] = _default;